// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class AlertService {
   $timeout: any
   alerts: any
   ngToast: any
   translationService: TranslationService
   constructor($timeout: any, translationService: TranslationService, ngToast: any) {
      /*
      Alerts attributes
      type: 'success'|'danger'|'info'|'primary'|'warning', Default: 'success'
      class: String, Default: ''
      msg: false|String
      retry: Boolean, Default: false(undefined)
    */
      this.toastAlert = this.toastAlert.bind(this)
      this.resetToastAlert = this.resetToastAlert.bind(this)
      this.setAlert = this.setAlert.bind(this)
      this.resetAlert = this.resetAlert.bind(this)
      this.pulseAlert = this.pulseAlert.bind(this)
      this.$timeout = $timeout
      this.translationService = translationService
      this.ngToast = ngToast
      this.alerts = {
         emailNotify: {
            class: 'email-notifier alertFade', 
            msg: false
         },
         pageRequestError: {
            type: 'danger',
            msg: false,
            retry: true
         },
         facetError: {
            type: 'danger',
            msg: false,
            retry: true
         },
         contentTypesError: {
            type: 'danger',
            msg: false,
            retry: true
         },
         disciplinesError: {
            type: 'danger',
            msg: false,
            retry: true
         },
         languagesError: {
            type: 'danger',
            msg: false,
            retry: true
         },
         libraryError: {
            type: 'danger',
            msg: false,
            retry: true
         },
         // Citation Trail
         citationTrailError: {
            type: 'danger',
            msg: false,
            retry: true
         },
         // Bibliographic citations like APA or MLA
         citationError: {
            type: 'danger',
            msg: false,
            retry: true
         },
         citationEmailError: {
            type: 'danger',
            msg: false,
            retry: true
         },
         bulkExportError: {
            type: 'danger',
            msg: this.translationService.translations.BULK_EXPORT_ERROR,
            retry: true
         },
         bulkExportSuccess: {
            type: 'success',
            msg: this.translationService.translations.BULK_EXPORT_SUCCESS,
            retry: false
         },
         feedbackError: {
            type: 'danger',
            msg: false,
            retry: true
         },
         chatEmailError: {
            type: 'danger',
            msg: false,
            retry: true
         },
         cloudStorageApiError: {
            type: 'warning',
            msg: false,
            retry: false
         },
         googleSignOut: {
            class: 'alertFade',
            type: 'success',
            msg: false,
            retry: false
         },
         cloudStorageSignOut: {
            class: 'alertFade',
            type: 'success',
            msg: false,
            retry: false
         },
         savedSearchSuccess: {
            iconClass: 'uxf-icon uxf-check uxf-green',
            class: 'alertFade',
            type: 'success',
            msg: false,
            retry: false
         },
         savedItemSuccess: {
            iconClass: 'uxf-icon uxf-check uxf-green',
            class: 'alertFade',
            type: 'success',
            msg: false,
            retry: false
         },
         savedSearchError: {
            type: 'warning',
            msg: false,
            retry: true
         },
         relatedItemsError: {
            type: 'danger',
            msg: false,
            retry: true
         },
         requestHoldError: {
            type: 'danger',
            msg: false,
            retry: false
         },
         sierraApiError: {
            type: 'danger',
            msg: false,
            retry: false
         },
         libraryCardError: {
            type: 'danger',
            msg: false,
            retry: false
         },
         libraryCardListLoadError: {
            type: 'danger',
            msg: false,
            retry: true
         },
         libraryCardSuccess: {
            type: 'success',
            msg: false,
            retry: false
         },
         authenticationNotice: {
            type: 'success',
            msg: false,
            retry: false
         },
         requestHoldSuccess: {
            iconClass: 'uxf-icon uxf-check uxf-green',
            type: 'success',
            msg: false,
            retry: false
         }
      }
   }

   toastAlert(name: any, alertMsg = 'An error occurred', type: any, prefix = '', resetExisting = true) {
      if (this.alerts[name] == null) { throw new Error(this.translationService.translations.ALERT_NAME_DOES_NOT_EXIST) }
    
      let dismissOnTimeout = true
      if (type === 'danger') {
         dismissOnTimeout = false
      }
    
      if (resetExisting) {
         this.resetToastAlert(name)
      }
      if (prefix) {
         alertMsg = `${prefix}: ${alertMsg}`
      }
      return this.alerts[name].toast = this.ngToast.create({content: alertMsg, className: type, dismissOnTimeout })
   }

   toast(name: any, alertMsg?: string) {
      const msg = alertMsg || this.alerts[name].msg || 'An error occurred'
      let dismissOnTimeout = true
      const type = this.alerts[name].type 

      if (type === 'danger') {
         dismissOnTimeout = false
      }
      return this.alerts[name].toast = this.ngToast.create({content: msg, className: type, dismissOnTimeout })
   }

   
   resetToastAlert(name: any) {
      if (this.alerts[name] == null) { throw new Error(this.translationService.translations.ALERT_NAME_DOES_NOT_EXIST) }
      if (this.alerts[name].toast != null) {
         return this.ngToast.dismiss(this.alerts[name].toast)
      }
   }

   setAlert(name: any, alertMsg = 'An error occurred', retryText = '') {
      if (this.alerts[name] == null) { throw new Error(this.translationService.translations.ALERT_NAME_DOES_NOT_EXIST) }
      this.alerts[name].msg = alertMsg
      return this.alerts[name].retryText = retryText
   }

   resetAlert(name: any) {
      if (this.alerts[name] == null) { throw new Error(this.translationService.translations.ALERT_NAME_DOES_NOT_EXIST) }
      return this.alerts[name].msg = false
   }

   pulseAlert(alert: any, msg: any, time = 2500, retryText = '') {
      this.setAlert(alert, msg, retryText)
      return this.$timeout(() => {
         return this.resetAlert(alert)
      }
      , time)
   }
}

AlertService.$inject = ['$timeout', 'translationService', 'ngToast']

angular.module('summonApp.services')
   .service('alertService', AlertService)
